import { CommonModule, CurrencyPipe, DatePipe, formatDate } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, FormArray, FormGroup, UntypedFormArray, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { ActivatedRoute, Router } from '@angular/router';
import { VatOption, EnumViewModel, PurchaseOrderDto, PurchaseOrderHireItemDto, PurchaseOrderPaymentDto, ProductDto, SupplierDto, PurchaseOrderStatus, ApplicationInfoDto, CustomerResponse, CustomerContactListItemDto, PurchaseOrderPartItemDto, PartResponse, PurchaseOrderProductItemDto, DlmProductDto, SalesOrderLineItemPriority, PurchaseOrderListDto, BomDto, WorkOrderListDto, WorkOrderStatus, DealCategory, GoodsInReceiptDto, GoodsInStatus } from 'app/api/models';
import { BomService, CostManagerService, CustomerService, DealService, DlmProductService, GoodsInService, PartService, PickSheetService, ProductService, PurchaseOrderService, SettingsService, SupplierService, WorkOrderService } from 'app/api/services';
import { PurchaseOrderPreviewComponent } from './purchase-order-preview/purchase-order-preview.component';
import jsPDF from 'jspdf';
import { FuseConfirmationService } from '@fuse/services/confirmation';
import { AppLoaderService } from 'app/core/services/app-loader/app-loader.service';
import { sumList } from 'app/app.component';
import { TimeUtil } from 'app/core/utils/time-utils';
import { MatCheckboxChange, MatCheckboxModule } from '@angular/material/checkbox';
import { AddItemDialogComponent } from 'app/core/components/add-item-dialog/add-item-dialog.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AppAuthService } from 'app/api/services/cookie-jwt-auth/app-auth.service';
import { SharedModule } from 'app/core/shared.module';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NgxPrintModule } from 'ngx-print';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatStepperModule } from '@angular/material/stepper';
import { MatOptionModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { isNumber } from 'lodash';
import { StepperSelectionEvent } from '@angular/cdk/stepper';
import { PurchaseOrderUtils } from '../purchase-order-utils';
import { GenericInfoDialogService } from 'app/core/services/generic-info-dialog/infoDialog.service';
import { MatRadioChange, MatRadioModule } from '@angular/material/radio';
import { WorkOrderDialogComponent } from '../../production/work-orders/work-order-dialog/work-order-dialog.component';
import { forkJoin, mapTo, tap } from 'rxjs';
import { GoodsInDialogComponent } from '../../parts-register/goods-in/goods-in-dialog/goods-in-dialog.component';

@Component({
  selector: 'app-purchase-order-builder',
  templateUrl: './purchase-order-builder.component.html',
  styleUrls: [ './purchase-order-builder.component.scss' ],
  standalone: true,
  imports: [
        CommonModule,
        SharedModule,
        MatSidenavModule,
        MatButtonModule,
        CdkScrollable,
        MatPaginatorModule,
        MatIconModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatOptionModule,
        FormsModule,
        ReactiveFormsModule,
        MatStepperModule,
        CurrencyPipe,
        FormsModule,
        MatDatepickerModule,
        MatAutocompleteModule,
        NgxPrintModule,
        MatSlideToggleModule,
        MatTooltipModule,
        MatCheckboxModule,
        MatRadioModule,
        PurchaseOrderPreviewComponent,
        WorkOrderDialogComponent,
  ],
})
export class PurchaseOrderBuilderComponent {
  @ViewChild("purchaseOrderPreview") purchaseOrderPreview: PurchaseOrderPreviewComponent;

  isLoading: boolean = false;

  paymentFormGroup: UntypedFormGroup;
  workOrderFormGroup: UntypedFormGroup;
  firstFormGroup: UntypedFormGroup;
  secondFormGroup: UntypedFormGroup;
  thirdFormGroup: UntypedFormGroup;

  public purchaseOrderId: number;
  public purchaseOrder: PurchaseOrderDto = {};
  public linkedPos: PurchaseOrderListDto[] = [];

  public purchaseOrderPayments: PurchaseOrderPaymentDto[] = [];
  public purchaseOrderHireItems: PurchaseOrderHireItemDto[] = [];
  public purchaseOrderPartItems: PurchaseOrderPartItemDto[] = [];
  public purchaseOrderProductItems: PurchaseOrderProductItemDto[] = [];

  public contacts: CustomerContactListItemDto[] = [];
  public contact: CustomerContactListItemDto;
  public company: CustomerResponse;
  public supplier: SupplierDto;
  
  companies: CustomerResponse[] = [];
  suppliers: SupplierDto[] = [];

  public assets: ProductDto[] = [];
  public filteredAssets: ProductDto[] = [];
  public parts: PartResponse[] = [];
  public filteredParts: PartResponse[] = [];
  public products: DlmProductDto[] = [];
  public filteredProducts: DlmProductDto[] = [];
  public boms: BomDto[] = [];
  // public workOrders: WorkOrderListDto[] = [];

  public VatOption = VatOption;

  public vatOptions = Object.values(VatOption).filter(x => isNumber(x)).map(x => <EnumViewModel> {name: this.getVatOptionName(+x), value: <VatOption>x});
  public salesOrderPriorities = Object.values(SalesOrderLineItemPriority).filter(x => isNumber(x)).map(x => <EnumViewModel> {name: this.getPriorityName(+x), value: <SalesOrderLineItemPriority>x});
  public categories = Object.values(DealCategory).filter(x => isNumber(x)).map(x => <EnumViewModel> {name: this.getCategoryName(+x), value: <DealCategory>x});
    

  public canSaveAsDraft: boolean = true;
  public isClosedForEditing: boolean = false;
  public isSupplier: boolean = false;
  public isProduct: boolean = false; //only for sales orders - false is hire, true is product sales

  public appInfo: ApplicationInfoDto;
  public isAdmin: boolean = false;
  public hasWriteAccess: boolean = false;

  public grnId: number = null;

  public PurchaseOrderStatus = PurchaseOrderStatus;

  constructor(
    public dialogRef: MatDialogRef<PurchaseOrderBuilderComponent>,
    private _formBuilder: UntypedFormBuilder,
    public _fuseConfirmationService: FuseConfirmationService,
    public _infoDialogService: GenericInfoDialogService,
    private loader: AppLoaderService,
    private cdr: ChangeDetectorRef,
    public purchaseOrderService: PurchaseOrderService,
    public costManagerService: CostManagerService,
    public customerService: CustomerService,
    public assetService: ProductService,
    public partService: PartService,
    public productService: DlmProductService,
    public supplierService: SupplierService,
    public bomService: BomService,
    public workOrderService: WorkOrderService,
    public goodsInService: GoodsInService,
    public dealService: DealService,
    public pickSheetService: PickSheetService,
    public currencyPipe: CurrencyPipe,
    public datePipe: DatePipe,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    public settingsService: SettingsService,
    private appAuth: AppAuthService,
    @Inject(MAT_DIALOG_DATA) public data: {
      purchaseOrderId?: number, assetId?: number, partId?: number, isSupplier?: boolean, isProduct?: boolean,
      companyName?: string, contactId?: number, triggerHandover?: boolean
    }
  ) {
  }

  async ngOnInit()
  {
    this.isSupplier = this.data?.isSupplier || false;
    this.isProduct = this.data?.isProduct || false;

    this.isAdmin = this.appAuth.isAdmin();
    this.hasWriteAccess = !this.isSupplier || PurchaseOrderUtils.hasWriteAccessToPurchaseOrders(this.appAuth.getUser());

    this.loader.open();
    forkJoin({
        a: this.loadClients(),
        b: this.loadAssets(),
        c: this.loadParts(),
        d: this.loadProducts(),
        e: this.loadAppInfo(),
        f: this.loadContacts(),
        g: this.loadSuppliers(),
    }).subscribe({
        next: () => {
            this.loader.close();

            var purchaseOrderId = this.data?.purchaseOrderId;
            var assetId = this.data?.assetId;
            var partId = this.data?.partId;

            this.canSaveAsDraft = !purchaseOrderId;

            if (purchaseOrderId) {
                this.purchaseOrderId = purchaseOrderId;
                this.loadPurchaseOrder();
            }
            else if (partId) {
              this.setupPurchaseOrderFromPart(partId);
            }
            else if (assetId) {
              this.setupPurchaseOrderFromAsset(assetId);
            }
            else {
              this.buildForm();
            }
        },
        error: () => {
            this.loader.close();
        }
    });
  }

  loadPurchaseOrder() {
    this.purchaseOrderService.apiPurchaseOrderGetPurchaseOrderPost$Json({ id: this.purchaseOrderId }).subscribe((res) => {
      this.purchaseOrder = res?.data;
      console.log("purchase order", this.purchaseOrderId, '\n', this.purchaseOrder);
      this.purchaseOrderHireItems = res?.data?.purchaseOrderHireItems ?? [];
      this.purchaseOrderPartItems = res?.data?.purchaseOrderPartItems ?? [];
      this.purchaseOrderProductItems = res?.data?.purchaseOrderProductItems ?? [];
      this.purchaseOrderPayments = res?.data?.purchaseOrderPayments ?? [];

      this.canSaveAsDraft = this.purchaseOrder?.isDraft // Not saved or saved as draft
      this.isClosedForEditing = +this.purchaseOrder.status >= +PurchaseOrderStatus.PendingApproval;

      this.isSupplier = this.purchaseOrder.isSupplier;
      this.isProduct = this.purchaseOrder.isProduct;

      //set up company/supplier, contact
      if(this.purchaseOrder.company)
          this.updateClient({value: this.purchaseOrder.company});

      if(this.purchaseOrder.supplier)
          this.updateSupplier({value: this.purchaseOrder.supplier});

      //linked POs
      if(this.isClosedForEditing && this.purchaseOrder.salesOrderRef2) {
        //load in linked PO/SO
        this.purchaseOrderService.apiPurchaseOrderPaginatedListGet$Json$Response({
          SearchTerm: this.purchaseOrder.salesOrderRef2,
          IsSupplier: (this.isHireOrder() || this.isSalesOrder()),
          IsProduct: this.isPurchaseOrder(),
          PageSize: 100,
        }).subscribe(res => {
          if(!res?.body?.data) return;
          this.linkedPos = res.body.data.items;
        });
      }

      //load in boms
      this.boms = [];
      for(var item of this.purchaseOrder.purchaseOrderProductItems)
        this.loadBomForProduct(item.productId);

      //see if there's a grn for this PO
      this.goodsInService.apiGoodsInGetForPurchaseOrderGet$Json$Response({purchaseOrderId: this.purchaseOrderId}).subscribe(res => {
        if(!res?.body?.data?.length) return;
        this.grnId = res.body.data[0].goodsInReceiptId;
      });

      this.buildForm();

      // Auto-trigger SAO handover if opened with triggerHandover flag
      if (this.data?.triggerHandover && this.isSalesOrder() && this.purchaseOrder?.status == PurchaseOrderStatus.Approved) {
        setTimeout(() => this.triggerSaoHandover(), 500);
      }
    });
  }

  setupPurchaseOrderFromAsset(assetId: number) {
    this.assetService.apiProductGetProductGet$Json$Response({productId: assetId}).subscribe(res => {
      if(!res?.body?.data) {
        this.buildForm();
        return;
      }

      var asset = res.body.data;

      this.purchaseOrderHireItems = [
        {
          description: asset.name,
          isStandby: false,
          hireFrom: null,
          hireTo: null,
          quantity: 1,
          price: asset.price,
          vat: VatOption.Standard,
        }
      ];
      this.purchaseOrder = {
        isSupplier: false,
        isProduct: false, //hire
        title: 'Hire Order for ' + asset.name,
        freightAmount: 0,
        purchaseOrderHireItems: this.purchaseOrderHireItems,
        purchaseOrderPartItems: [],
        purchaseOrderProductItems: [],
      };

      this.buildForm();
    });
  }

  setupPurchaseOrderFromPart(partId: number) {
    this.partService.apiPartPartGet$Json$Response({partId: partId}).subscribe(res => {
      if(!res?.body?.data) {
        this.buildForm();
        return;
      }

      var part = res.body.data;

      this.purchaseOrderPartItems = [
        {
          description: part.number,
          partId: part.id,
          quantity: 1,
          price: part.cost,
          vat: VatOption.Standard,
        }
      ];
      this.purchaseOrder = {
        isSupplier: true,
        isProduct: false,
        title: 'Purchase Order for ' + part.number,
        freightAmount: 0,
        purchaseOrderHireItems: [],
        purchaseOrderPartItems: this.purchaseOrderPartItems,
        purchaseOrderProductItems: [],
        supplier: this.data?.companyName ?? null,
        contactId: this.data?.contactId ?? null,
      };

      this.buildForm();
    });
  }

  loadClients() {
    return this.customerService.apiCustomerSearchAllGet$Json$Response().pipe(tap(res => {
        if (!res?.body?.data) return;

        this.companies = res.body.data;
    }),
    mapTo(void 0));
  }

  loadContacts() {
    return this.customerService.apiCustomerSearchContactsGet$Json$Response().pipe(tap(res => {
      if (!res?.body?.data) return;

      this.contacts = res.body.data;

      this.cdr.detectChanges();
    }),
    mapTo(void 0));
  }

  loadSuppliers() {
    return this.supplierService.apiSupplierGetAllGet$Json$Response().pipe(tap(res => {
      if(!res?.body?.data) return;
      this.suppliers = res.body.data;
    }),
    mapTo(void 0));
  }

  loadCompany(companyId: number) {
    this.customerService.apiCustomerCustomerGet$Json$Response({id: companyId}).subscribe(res => {
      if(!res?.body?.data) return;

      this.company = res.body.data;

      this.selectAddress({value: this.company.primaryInvoiceLocation?.location ?? this.company.address});

      if(this.purchaseOrder?.contactId && (this.isHireOrder() || this.isSalesOrder()))
        this.contact = this.contacts.find(p => p.id == this.purchaseOrder.contactId);

      //refresh the form so contact reliably shows
      const fg = this.firstFormGroup;
      fg?.setValue(fg.value);
      fg?.updateValueAndValidity({ emitEvent: false });
      this.cdr.detectChanges();
    });
  }

  public loadAppInfo() {
    return this.settingsService.apiSettingsAppInfoGet$Json$Response().pipe(tap(res => {
      if(!res?.body?.data) return;

      this.appInfo = res.body.data;
    }),
    mapTo(void 0));
  }

  loadBomForProduct(productId: number) {
    if(this.boms.find(x => x.productId == productId))
      return;

    this.bomService.apiBomBomByProductIdGet$Json$Response({productId: productId}).subscribe(res => {
        if(!res?.body?.data) return;
        this.boms.push(res.body.data);
      });
  }

  // loadWorkOrder(workOrderId: number) {
  //   if(!workOrderId) return;

  //   this.workOrderService.apiWorkOrderGetWorkOrderPost$Json$Response({id: workOrderId}).subscribe(res => {
  //     if(!res?.body?.data) return;
  //     this.workOrder = res.body.data;
  //   });
  // }

  getBom(itemControl: UntypedFormArray) {
    var productId = itemControl.controls['productId'].value;
    if(!productId) return null;
    
    return this.boms?.find(x => x.productId == productId);
  }
  countBomShortItems(itemControl: UntypedFormArray) {
    var bom = this.getBom(itemControl);
    var productQuantity = this.countProductShort(itemControl);
    if(!bom || !productQuantity) return 0;

    var shortCount = 0;
    for(var item of bom.items) {
      var part = this.parts?.find(X => X.id == item.partId);
      if(!part) continue;

      var requiredAmount = item.quantity * productQuantity;

      if(requiredAmount > part.currentStock)
        shortCount += requiredAmount - part.currentStock;
    }
    return shortCount;
  }
  countProductShort(itemControl: UntypedFormArray) {
    var required = itemControl.controls['quantity']?.value ?? 0;
    var stock = this.getProductStock(itemControl);

    if(required > stock)
      return required - stock;
    else
      return 0;
  }

  getVatOptionName(option: number) {
      switch(option) {
          case VatOption.Zero: return '0%';
          case VatOption.Reduced: return '5%';
          case VatOption.Standard: return '20%';
          default: return VatOption[option].toString();
      }
  }

  getPriorityName(priority: number) {
      switch(priority) {
          default: return SalesOrderLineItemPriority[priority].toString();
      }
  }

  getCategoryName(cat: number, nullAsAll = false) {
    if(cat == null && nullAsAll)
        return "All";

    switch(cat) {
        case DealCategory.StandardProducts: return 'Standard';
        case DealCategory.CustomProducts: return 'Custom';
        case DealCategory.CableWorkingGear: return 'Cable Working Gear';
        case DealCategory.MarineSales: return 'Marine';
        case DealCategory.NewLead: return 'New Lead';
        case DealCategory.RepeatCustomProduct: return 'Repeat Custom';
        default: return DealCategory[cat].toString();
    }
  }

  updateClient(event: any) {
    var selectedClient = event?.value;

    var companyId = this.companies.find(x => x.name == selectedClient)?.customerId;
    
    this.loadCompany(companyId);
  }

  updateSupplier(event: any) {
    var supplier = event?.value;
    if(!supplier) return;

    this.supplier = this.suppliers.find(x => x.name == supplier);
    
    if (this.purchaseOrder?.contactId && this.isPurchaseOrder())
      this.contact = this.supplier?.contacts.find(p => p.supplierContactId == this.purchaseOrder.contactId);

    // this.selectAddress({value: this.supplier.supplierAddresses?.length ? this.supplier.supplierAddresses[0].addressOne : '' });
  }

  updateFreightAmount(event: any) {
    console.log(event.target.value);
    this.purchaseOrder.freightAmount = +event.target.value;
  }

  setNewRef() {
    //gen new po/so ref
    if(this.purchaseOrder?.purchaseOrderId)
      this.purchaseOrderService.apiPurchaseOrderGetPoRefPost$Json$Response({body: this.purchaseOrder}).subscribe(res => {
        if(!res?.body) return;

        console.log("FOUND PO REF", res.body.message);
        this.purchaseOrder.salesOrderRef = res.body.message;
        this.firstFormGroup.controls['salesOrderRef'].setValue(res.body.message);
      });
    else
      this.purchaseOrderService.apiPurchaseOrderGetNextPoRefGet$Json$Response({isSupplier: this.isSupplier}).subscribe(res => {
        if(!res?.body) return;

        console.log("GENERATED PO REF", res.body.message);
        this.purchaseOrder.salesOrderRef = res.body.message;
        this.firstFormGroup.controls['salesOrderRef'].setValue(res.body.message);
      });
  }


  buildForm() { 
    this.paymentFormGroup = this._formBuilder.group({
      paymentItems: this._formBuilder.array([]) // This initializes the form array
    });

    this.firstFormGroup = this._formBuilder.group({
      title:      [this.purchaseOrder?.title ?? "", Validators.required],
      summary:    [this.purchaseOrder?.summary ?? ""],
      contact:    [this.purchaseOrder?.contactId, Validators.required],
      company:    [(this.isSupplier ? this.purchaseOrder?.supplier : this.purchaseOrder?.company) ?? "", Validators.required],
      isSupplier: [this.isSupplier || false],
      dealCategory: [this.purchaseOrder?.dealCategory ?? DealCategory.StandardProducts],
      
      salesOrderRef: [this.purchaseOrder?.salesOrderRef ?? ""],
      salesOrderRef2: [this.purchaseOrder?.salesOrderRef2 ?? ""],
    });

    // this.firstFormGroup.controls['salesOrderRef'].disable();

    if(!this.purchaseOrder?.salesOrderRef)
      this.setNewRef();

    this.secondFormGroup = this._formBuilder.group({
      // addressSelect: [null],
      address1:   [this.purchaseOrder?.addressOne ?? ""],
      address2:   [this.purchaseOrder?.addressTwo ?? ""],
      city:       [this.purchaseOrder?.city ?? ""],
      county:     [this.purchaseOrder?.county ?? ""],
      postcode:   [this.purchaseOrder?.postcode ?? ""],
    });

    //if this is a new supplier purchase order - grab address from company settings
    if(this.isPurchaseOrder() && !this.purchaseOrderId) {
      this.secondFormGroup.patchValue({
        address1:   this.appInfo.companyAddressOne,
        address2:   this.appInfo.companyAddressTwo,
        city:       this.appInfo.companyCity,
        county:     this.appInfo.companyCounty,
        postcode:   this.appInfo.companyPostcode,
      });
    }

    this.thirdFormGroup = this._formBuilder.group({
      hireItems:    this._formBuilder.array([], (c: FormArray) => this.itemsValidator(c, this.isHireOrder())),
      partItems:    this._formBuilder.array([], (c: FormArray) => this.itemsValidator(c, this.isPurchaseOrder())),
      productItems: this._formBuilder.array([], (c: FormArray) => this.itemsValidator(c, this.isSalesOrder())),
    });

    this.workOrderFormGroup = this._formBuilder.group({
      isWorkOrderFullShipment:  this.purchaseOrder?.isWorkOrderFullShipment ?? false,
      workOrderStartDate:       this.purchaseOrder?.workOrderStartDate ?? TimeUtil.setTo1amUTC(new Date()),
      workOrderDueDate:         this.purchaseOrder?.workOrderDueDate ?? TimeUtil.addDays(TimeUtil.setTo1amUTC(new Date()), 7),
      workOrderPriority:        this.purchaseOrder?.workOrderPriority ?? SalesOrderLineItemPriority.Normal,
      workOrderNotes:           this.purchaseOrder?.workOrderNotes ?? '',
    });

    this.purchaseOrderHireItems?.forEach((item: PurchaseOrderHireItemDto) => this.addPurchaseOrderHireItem(item));
    this.purchaseOrderPartItems?.forEach((item: PurchaseOrderPartItemDto) => this.addPurchaseOrderPartItem(item));
    this.purchaseOrderProductItems?.forEach((item: PurchaseOrderPartItemDto) => this.addPurchaseOrderProductItem(item));
    this.purchaseOrderPayments?.forEach((item: PurchaseOrderPaymentDto) => this.addPurchaseOrderPayment(item));
    
    if(!this.hasWriteAccess) {
      this.firstFormGroup.disable();
      this.paymentFormGroup.disable();
      this.secondFormGroup.disable();
      this.thirdFormGroup.disable();
      this.workOrderFormGroup.disable();
    }
  }

  itemsValidator(control: FormArray, required: boolean): { [key: string]: boolean } | null {
    if (required && control.length < 1) {
      return { 'noItems': true };
    }
    return null;
  }
    
  // Helper methods to get the purchase order items form array
  get hireItems(): FormArray {
    return this.thirdFormGroup ? this.thirdFormGroup?.get('hireItems') as FormArray : null;
  }
  get partItems(): FormArray {
    return this.thirdFormGroup ? this.thirdFormGroup?.get('partItems') as FormArray : null;
  }
  get productItems(): FormArray {
    return this.thirdFormGroup ? this.thirdFormGroup?.get('productItems') as FormArray : null;
  }

  // Method to add a new item FormControl to the items FormArray
  addPurchaseOrderHireItem(existingItem: PurchaseOrderHireItemDto = null) {
    this.hireItems?.push(this.newHireItem(existingItem));
    this.filteredAssets = this.assets; //reset filtering
    this.cdr.detectChanges();
  }
  addPurchaseOrderPartItem(existingItem: PurchaseOrderPartItemDto = null) {
    this.partItems?.push(this.newPartItem(existingItem));
    this.filteredParts = this.parts; //reset filtering
    this.cdr.detectChanges();
  }
  addPurchaseOrderProductItem(existingItem: PurchaseOrderProductItemDto = null) {
    this.productItems?.push(this.newProductItem(existingItem));
    this.filteredProducts = this.products; //reset filtering
    this.cdr.detectChanges();
  }

  // Method to create a new FormControl for an item
  newHireItem(existingItem: PurchaseOrderHireItemDto = null): FormGroup {
    return this._formBuilder.group({
      purchaseOrderItemId:  [ existingItem?.purchaseOrderItemId ?? null ],
      description:          [ existingItem?.description ?? '',              Validators.required],
      price:                [ existingItem?.price ?? 0,                     [Validators.required, Validators.min(0.01)]],
      isStandby:            [existingItem?.isStandby ?? false],
      quantity:             [ existingItem?.quantity ?? 1,                  [Validators.required, Validators.min(1)]],
      hireFrom:             [ existingItem?.hireFrom,                       Validators.required],
      hireTo:               [ existingItem?.hireTo],
      vat:                  [ existingItem?.vat ?? VatOption.Standard,      Validators.required],
    });
  }
  newPartItem(existingItem: PurchaseOrderPartItemDto = null): FormGroup {
    return this._formBuilder.group({
      purchaseOrderItemId:    [ existingItem?.purchaseOrderItemId ?? null ],
      description:            [ existingItem?.description ?? '',              Validators.required],
      price:                  [ existingItem?.price ?? 0,                     [Validators.required, Validators.min(0.01)]],
      quantity:               [ existingItem?.quantity ?? 1,                  [Validators.required, Validators.min(1)]],
      vat:                    [ existingItem?.vat ?? VatOption.Standard,      Validators.required],
      requiredDeliveryDate:   [ existingItem?.requiredDeliveryDate ?? null,   Validators.required],
      partId:                 [ existingItem?.partId ?? null,                  Validators.required],
    });
  }
  newProductItem(existingItem: PurchaseOrderProductItemDto = null): FormGroup {
    return this._formBuilder.group({
      purchaseOrderItemId:    [ existingItem?.purchaseOrderItemId ?? null ],
      description:            [ existingItem?.description ?? '',              Validators.required],
      price:                  [ existingItem?.price ?? 0,                     [Validators.required, Validators.min(0.01)]],
      quantity:               [ existingItem?.quantity ?? 1,                  [Validators.required, Validators.min(1)]],
      vat:                    [ existingItem?.vat ?? VatOption.Standard,      Validators.required],
      requiredDeliveryDate:   [ existingItem?.requiredDeliveryDate ?? null,   Validators.required],
      priority:               [ existingItem?.priority ?? SalesOrderLineItemPriority.Normal,   Validators.required],
      productId:              [ existingItem?.productId ?? null,                  Validators.required],
    });
  }

  deleteHireItem(index: number) {
    this.hireItems?.removeAt(index);
    this.cdr.detectChanges();
  }
  deletePartItem(index: number) {
    this.partItems?.removeAt(index);
    this.cdr.detectChanges();
  }
  deleteProductItem(index: number) {
    this.productItems?.removeAt(index);
    this.cdr.detectChanges();
  }

  // Helper methods to get the paymentitems form array
  get paymentItems(): FormArray {
    return this.paymentFormGroup ? this.paymentFormGroup?.get('paymentItems') as FormArray : null;
  }

  // Method to add a new item FormControl to the items FormArray
  addPurchaseOrderPayment(existingItem: PurchaseOrderPaymentDto = null) {
    this.paymentItems?.push(this.newPayment(existingItem));
    this.cdr.detectChanges();
  }

  // Method to create a new FormControl for an item
  newPayment(existingItem: PurchaseOrderPaymentDto = null): FormGroup {
    return this._formBuilder.group({
      purchaseOrderPaymentId: [ existingItem?.purchaseOrderPaymentId ],
      amount: [ existingItem?.amount ?? 0, [Validators.required, Validators.min(0.01)]],
      date: [ formatDate(TimeUtil.setTo1amUTC(existingItem?.date ? new Date(existingItem?.date) : new Date()), "yyyy-MM-dd", "en"), Validators.required],
    });
  }

  deletePaymentItem(index: number) {
    this.paymentItems?.removeAt(index);
    this.cdr.detectChanges();
  }

  getModalTitle() {
    var orderType = (this.isSalesOrder() ? 'Sales' : this.isPurchaseOrder() ? 'Purchase' : 'Hire') + " Order";

    if(this.isClosedForEditing)
      return orderType + ": " + this.purchaseOrder?.salesOrderRef;
    else
      return orderType + " Builder";
  }

  getFurthestDeliveryDate() {
    if (this.isHireOrder()) return '-';

    var dates = [
      ...this.purchaseOrder?.purchaseOrderPartItems.map(x => x.requiredDeliveryDate),
      ...this.purchaseOrder?.purchaseOrderProductItems.map(x => x.requiredDeliveryDate),
    ].filter(x => !!x).map(x => new Date(x).getTime());

    if (!dates?.length)
      return '-';
    else {
      var maxTime = Math.max(...dates);
      return this.datePipe.transform(new Date(maxTime), 'dd/MM/yyyy');
    }
  }

  buildModel(draft: boolean = false) {
      this.purchaseOrder.isDraft = draft;

      var category = this.firstFormGroup?.get('dealCategory').value;
      var isCustomProduct = category === DealCategory.CustomProducts || category === DealCategory.RepeatCustomProduct;

      if(draft)
        this.purchaseOrder.status = PurchaseOrderStatus.Draft;
      else if (!this.purchaseOrderId || this.purchaseOrder.status == PurchaseOrderStatus.Draft) {
        this.purchaseOrder.status = isCustomProduct ? PurchaseOrderStatus.AwaitingCustomerApproval : PurchaseOrderStatus.Approved;

        // Capture approval audit trail for auto-approved SOs
        if (this.purchaseOrder.status == PurchaseOrderStatus.Approved && !this.purchaseOrder.approvedByName) {
          var user = this.appAuth.getUser();
          this.purchaseOrder.approvedByName = `${user?.firstName} ${user?.lastName}`.trim();
          this.purchaseOrder.approvalDate = new Date().toISOString();
        }
      }
    
      this.purchaseOrder.title = this.firstFormGroup?.get('title').value?.trim();
      this.purchaseOrder.summary = this.firstFormGroup?.get('summary').value?.trim();
      this.purchaseOrder.contactId = this.firstFormGroup?.get('contact').value;
      this.purchaseOrder.salesOrderRef = this.firstFormGroup?.get('salesOrderRef').value;
      this.purchaseOrder.salesOrderRef2 = this.firstFormGroup?.get('salesOrderRef2').value?.trim();
      this.purchaseOrder.dealCategory = this.firstFormGroup?.get('dealCategory').value;

      this.purchaseOrder.isSupplier = this.isSupplier;
      this.purchaseOrder.isProduct = this.isProduct;

      this.purchaseOrder.supplier = this.isSupplier ? this.firstFormGroup?.get('company').value : null;
      this.purchaseOrder.company = this.isSupplier ? null : this.firstFormGroup?.get('company').value;

      this.purchaseOrder.addressOne = this.secondFormGroup?.get('address1').value?.trim();
      this.purchaseOrder.addressTwo = this.secondFormGroup?.get('address2').value?.trim();
      this.purchaseOrder.city = this.secondFormGroup?.get('city').value?.trim();
      this.purchaseOrder.county = this.secondFormGroup?.get('county').value?.trim();
      this.purchaseOrder.postcode = this.secondFormGroup?.get('postcode').value?.trim();

      if(this.requiresWorkOrder()) {
        this.purchaseOrder.isWorkOrderFullShipment = this.workOrderFormGroup?.get('isWorkOrderFullShipment').value;
        this.purchaseOrder.workOrderStartDate = this.workOrderFormGroup?.get('workOrderStartDate').value;
        this.purchaseOrder.workOrderDueDate = this.workOrderFormGroup?.get('workOrderDueDate').value;
        this.purchaseOrder.workOrderPriority = this.workOrderFormGroup?.get('workOrderPriority').value;
        this.purchaseOrder.workOrderNotes = this.workOrderFormGroup?.get('workOrderNotes').value;
      }
      
      // hire items
      this.purchaseOrderHireItems = [];
      this.hireItems?.controls?.forEach((itemControl: FormGroup) => {
        this.recalculateQuantity(itemControl, true);

        var item: PurchaseOrderHireItemDto = {
          purchaseOrderItemId: itemControl?.get("purchaseOrderItemId").value,
          description: itemControl?.get("description").value,
          price: itemControl?.get("price").value,
          isStandby: itemControl?.get("isStandby").value ?? false,
          quantity: itemControl?.get("quantity").value,
          hireFrom: TimeUtil.setTo1amUTC(new Date(itemControl?.get('hireFrom').value)).toISOString(),
          hireTo: itemControl?.get('hireTo').value ? TimeUtil.setTo1amUTC(new Date(itemControl?.get('hireTo').value)).toISOString() : null,
          vat: itemControl?.get("vat").value,
        };

        this.purchaseOrderHireItems?.push(item);
      });
      this.purchaseOrder.purchaseOrderHireItems = this.purchaseOrderHireItems;
      
      // part items
      this.purchaseOrderPartItems = [];
      this.partItems?.controls?.forEach((itemControl: FormGroup) => {
        var item: PurchaseOrderPartItemDto = {
          purchaseOrderItemId: itemControl?.get("purchaseOrderItemId").value,
          description: itemControl?.get("description").value,
          price: itemControl?.get("price").value,
          quantity: itemControl?.get("quantity").value,
          vat: itemControl?.get("vat").value,
          requiredDeliveryDate: itemControl?.get("requiredDeliveryDate").value,
          partId: itemControl?.get("partId").value,
        };

        this.purchaseOrderPartItems?.push(item);
      });
      this.purchaseOrder.purchaseOrderPartItems = this.purchaseOrderPartItems;
      
      // product items
      this.purchaseOrderProductItems = [];
      this.productItems?.controls?.forEach((itemControl: FormGroup) => {
        var item: PurchaseOrderProductItemDto = {
          purchaseOrderItemId: itemControl?.get("purchaseOrderItemId").value,
          description: itemControl?.get("description").value,
          price: itemControl?.get("price").value,
          quantity: itemControl?.get("quantity").value,
          vat: itemControl?.get("vat").value,
          requiredDeliveryDate: itemControl?.get("requiredDeliveryDate").value,
          priority: itemControl?.get("priority").value,
          productId: itemControl?.get("productId").value,
        };

        this.purchaseOrderProductItems?.push(item);
      });
      this.purchaseOrder.purchaseOrderProductItems = this.purchaseOrderProductItems;

      // payments
      this.purchaseOrderPayments = [];
      this.paymentItems?.controls?.forEach((itemControl: FormGroup) => {
        var item: PurchaseOrderPaymentDto = {
          purchaseOrderPaymentId: itemControl?.get("purchaseOrderPaymentId").value,
          amount: itemControl?.get("amount").value,
          date: itemControl?.get("date").value,
        };

        this.purchaseOrderPayments?.push(item);
      });

      this.purchaseOrder.amount = this.getGrandTotal();

      this.purchaseOrder.purchaseOrderPayments = this.purchaseOrderPayments;
  }

  updateContact(event: MatSelectChange){
    var value = event?.value;

    if (!value || isNaN(value)) value = 0;

    this.firstFormGroup?.controls["contact"].setValue(value);
    this.contact = this.contacts.find(p => p.id == value);
  }

  updateSupplierContact(event: MatSelectChange) {
    var value = event?.value;

    if (!value || isNaN(value)) value = 0;

    this.firstFormGroup?.controls["contact"].setValue(value);
    this.contact = this.supplier?.contacts.find(x => x.supplierContactId == value);
  }

  selectAddress(event: any) {
    var value = event?.value;

    // var address = this.company?.invoiceAddresses.find(x => x.projectAddressId == value);

    // this.secondFormGroup?.controls["addressSelect"].setValue(value);
    this.secondFormGroup?.controls["address1"].setValue(value);
    // this.secondFormGroup?.controls["address2"].setValue("");
    // this.secondFormGroup?.controls["city"].setValue("");
    // this.secondFormGroup?.controls["county"].setValue("");
    // this.secondFormGroup?.controls["postcode"].setValue("");

    this.cdr.detectChanges();
  }

  // getFullAddress(address: ProjectAddressDto) {
  //   var addressString = "";

  //   if(address?.addressOne)
  //     addressString += address.addressOne + ", ";

  //   if(address?.addressTwo)
  //     addressString += address.addressTwo + ", ";

  //   if(address?.city)
  //     addressString += address.city + ", ";

  //   if(address?.county)
  //     addressString += address.county + ", ";

  //   if(address?.postcode)
  //     addressString += address.postcode + ", ";

  //   if(addressString.endsWith(", "))
  //     addressString = addressString.substring(0, addressString.length - 2);

  //   return addressString;
  // }

  loadAssets() {
    return this.assetService.apiProductGetAllGet$Json$Response().pipe(tap(res => {
      if(!res?.body?.data) return;

      this.assets = res.body.data;
      this.filteredAssets = this.assets;
    }),
    mapTo(void 0));
  }
  loadParts() {
    return this.partService.apiPartPartsGet$Json$Response().pipe(tap(res => {
      if(!res?.body?.data) return;

      this.parts = res.body.data;//.filter(x => x.isAtexApproved == this.suppliers.find(s => s.name == this.firstFormGroup.controls['company'].value)?.isAtexApproved);//.filter(x => x.primarySupplier == this.firstFormGroup.controls['company'].value);
      this.filteredParts = this.parts;
    }),
    mapTo(void 0));
  }
  loadProducts() {
    return this.productService.apiDlmProductGetProductsGet$Json$Response().pipe(tap(res => {
      if(!res?.body?.data) return;

      this.products = res.body.data;
      this.filteredProducts = this.products;
    }),
    mapTo(void 0));
  }

  filterAssets(event: any) {
    this.filteredAssets = this.assets.filter(m => m.name.toLowerCase().includes(event.target.value.toLowerCase()));
  }
  filterParts(event: any) {
    this.filteredParts = this.parts.filter(m => m.number.toLowerCase().includes(event.target.value.toLowerCase()));
  }
  filterProducts(event: any) {
    this.filteredProducts = this.products.filter(m => m.partNumber.toLowerCase().includes(event.target.value.toLowerCase()));
  }

  onHireItemSelected(event: any, itemControl: UntypedFormArray) {
    var assetName = event.option.value;

    itemControl?.controls["description"].setValue(assetName);
    itemControl?.controls["price"].setValue(this.assets.find(x => x.name == assetName)?.price ?? 0);
  }
  onPartItemSelected(event: any, itemControl: UntypedFormArray) {
    var partNumber = event.option.value;
    var partId = this.parts.find(x => x.number.toLowerCase() == partNumber.toLowerCase())?.id ?? null;

    itemControl?.controls["description"].setValue(partNumber);
    itemControl?.controls["partId"].setValue(partId);
    itemControl?.controls["price"].setValue(this.parts.find(x => x.number == partNumber)?.cost ?? 0);
  }
  onProductItemSelected(event: any, itemControl: UntypedFormArray) {
    var partNumber = event.option.value;
    var productId = this.products.find(x => x.partNumber.toLowerCase() == partNumber.toLowerCase())?.dlmProductId ?? null;

    itemControl?.controls["description"].setValue(partNumber);
    itemControl?.controls["productId"].setValue(productId);
    itemControl?.controls["price"].setValue(this.products.find(x => x.partNumber == partNumber)?.price ?? 0);

    this.loadBomForProduct(productId);
  }

  partIsNonStock(itemControl: UntypedFormArray) {
    var partId = itemControl?.controls["partId"].value;
    return this.parts?.find(x => x.id == partId)?.isNonStock;
  }
  partIsFlagged(itemControl: UntypedFormArray) {
    var partId = itemControl?.controls["partId"].value;
    var part = this.parts?.find(x => x.id == partId);
    return part?.isHighRisk || part?.isCritical;
  }
  partIsOverMaxStock(itemControl: UntypedFormArray) {
    var partId = itemControl?.controls["partId"].value;
    var part = this.parts?.find(x => x.id == partId);
    return part?.currentStock + itemControl?.controls['quantity'].value > part?.maximumStock;
  }
  getPartMaxStock(itemControl: UntypedFormArray) {
    var partId = itemControl?.controls["partId"].value;
    var part = this.parts?.find(x => x.id == partId);
    return `current: ${part?.currentStock ?? 0}, max: ${part?.maximumStock ?? 0}`;
  }

  getProductStock(itemControl: UntypedFormArray) {
    var productId = itemControl?.controls["productId"].value;
    var product = this.products?.find(x => x.dlmProductId == productId);
    return product?.freeStock;
  }
  lookupProduct(itemControl: UntypedFormArray) {
    return this.products?.find(x => x.dlmProductId == itemControl?.controls["productId"].value);
  }
  requiresWorkOrder = () =>
    this.isSalesOrder() &&
      (this.purchaseOrder?.workOrders?.length ||
        (this.productItems?.length > 0 && this.getProductItemsRequiringWorkOrder()?.length > 0)
      );

  // requiresBackOrder = () =>
  //   this.isSalesOrder() &&
  //     (this.purchaseOrder?.backOrders?.length ||
  //       (this.productItems?.length > 0 && this.getProductItemsRequiringBackOrder()?.length > 0)
  //     );
  
  productRequiresWorkOrder = (itemControl: UntypedFormArray) => this.countProductShort(itemControl) > 0;
  productHasWorkOrder = (itemControl: UntypedFormArray) => this.purchaseOrder?.workOrders?.some(x => x.productId == itemControl.controls['productId'].value);
  getProductItemsRequiringWorkOrder = () => this.productItems?.controls?.filter(this.productRequiresWorkOrder);
  getProductItemsRequiringButWithoutWorkOrder = () => {
    var itemsNeedingWO = this.getProductItemsRequiringWorkOrder() ?? [];
    var existingWOs = this.purchaseOrder?.workOrders ?? [];
    var result = [];

    // Count how many WOs exist per productId
    var woCountByProduct: { [key: number]: number } = {};
    for (var wo of existingWOs) {
      woCountByProduct[wo.productId] = (woCountByProduct[wo.productId] || 0) + 1;
    }

    // Count how many line items we've already accounted for per productId
    var accountedByProduct: { [key: number]: number } = {};
    for (var item of itemsNeedingWO) {
      var productId = (item as UntypedFormArray).controls['productId'].value;
      accountedByProduct[productId] = (accountedByProduct[productId] || 0) + 1;
      var existingCount = woCountByProduct[productId] || 0;

      // Only skip if there are still enough existing WOs to cover this line item
      if (accountedByProduct[productId] > existingCount) {
        result.push(item);
      }
    }

    return result;
  };

  productRequiresBackOrder = (itemControl: UntypedFormArray) => this.countBomShortItems(itemControl) > 0;
  getProductItemsRequiringBackOrder = () => this.productItems?.controls?.filter(this.productRequiresBackOrder);

  preventFlaggedPartsProceed() {
    //always let admins proceed
    if(this.isAdmin)
      return false;

    for(var part of this.partItems.controls) {
      var itemControl = part as UntypedFormArray;
      if(this.partIsNonStock(itemControl) || this.partIsFlagged(itemControl) || this.partIsOverMaxStock(itemControl))
        return true;
    }
  }

  isHireOrder = () =>     !this.isSupplier && !this.isProduct;
  isPurchaseOrder = () => this.isSupplier && !this.isProduct;
  isSalesOrder = () =>    !this.isSupplier && this.isProduct;

  hasAssets = () => this.hireItems?.controls.length > 0;
  hasParts = () => this.partItems?.controls.length > 0;
  hasProducts = () => this.productItems?.controls.length > 0;

  updateCurrency(event: any, itemControl: UntypedFormArray, controlName: string){
    var value = parseFloat(
      event.target.value.replace("£", "").replace(",", "")
    );

    if (!value || isNaN(value)) value = 0;

    itemControl?.controls[controlName].setValue(value);
  }

  updateVAT(event: MatSelectChange, itemControl: UntypedFormArray){
    var value = event?.value;

    if (!value || isNaN(value)) value = 0;

    itemControl?.controls["vat"].setValue(value);
  }

  getVatValue(vatOption: VatOption){
    switch(vatOption){
      case VatOption.Reduced:
        return 0.05;
      case VatOption.Standard:
        return 0.2;
      case VatOption.Zero:
      default:
        return 0;
    }
  }

  recalculateQuantity(itemControl: FormGroup, setQuantity: boolean = false) {
    var hireFrom = TimeUtil.setTo1amUTC(new Date(itemControl?.get('hireFrom').value));
    var hireTo = itemControl?.get('hireTo').value ? TimeUtil.setTo1amUTC(new Date(itemControl?.get('hireTo').value)) : null;
    var days = hireTo ? TimeUtil.getDaysBetween(hireFrom, hireTo) : 1;

    //todo minus any days that are on standby
    if(hireTo && days && !itemControl.controls['isStandby'].value) {
      var standbyItems: PurchaseOrderHireItemDto[] = this.thirdFormGroup.value.hireItems.filter(x => (<string>x.description).startsWith(itemControl.controls['description'].value) && x.isStandby && x.hireTo);
      var standbyDays = sumList(standbyItems.map(x => TimeUtil.getDaysBetween(TimeUtil.getBiggestDate(new Date(x.hireFrom), hireFrom), TimeUtil.getSmallestDate(new Date(x.hireTo), hireTo))));

      days -= standbyDays;
    };

    if(setQuantity)
      itemControl.controls['quantity'].setValue(days);

    return days;
  }

  getHireItemSubtotal(itemControl: FormGroup, includeVat: boolean = false) {
    var price = itemControl?.get('price').value;
    // var quantity = itemControl?.get('quantity').value;
    var quantity = this.recalculateQuantity(itemControl);

    var vat = this.getVatValue(parseInt(itemControl?.get('vat').value) ?? 0);
    
    return (price * quantity) * ((includeVat ? vat : 0) + 1);
  }

  getPartItemSubtotal(itemControl: FormGroup, includeVat: boolean = false) {
    var price = itemControl?.get('price').value;
    var quantity = itemControl?.get('quantity').value;

    var vat = this.getVatValue(parseInt(itemControl?.get('vat').value) ?? 0);
    
    return (price * quantity) * ((includeVat ? vat : 0) + 1);
  }

  getTotalForControl(controlName: string) {
    var subtotal = 0;

    this.hireItems?.controls.forEach((itemControl: FormGroup) => {
      subtotal += itemControl?.get(controlName).value;
    });

    return subtotal;
  }

  // items
  getGrandSubTotal() {
    var subtotal = 0;

    this.hireItems?.controls.forEach((itemControl: FormGroup) => {
      subtotal += itemControl?.get('price').value * this.recalculateQuantity(itemControl);
    });
    this.partItems?.controls.forEach((itemControl: FormGroup) => {
      subtotal += itemControl?.get('price').value * itemControl?.get('quantity').value;
    });
    this.productItems?.controls.forEach((itemControl: FormGroup) => {
      subtotal += itemControl?.get('price').value * itemControl?.get('quantity').value;
    });

    return subtotal;
  }

  getTotalVat() {
    var subtotal = 0;

    this.hireItems?.controls.forEach((itemControl: FormGroup) => {
      subtotal += ((itemControl?.get("price").value * this.recalculateQuantity(itemControl)) * this.getVatValue(itemControl?.get("vat").value));
    });
    this.partItems?.controls.forEach((itemControl: FormGroup) => {
      subtotal += ((itemControl?.get("price").value * itemControl?.get('quantity').value) * this.getVatValue(itemControl?.get("vat").value));
    });
    this.productItems?.controls.forEach((itemControl: FormGroup) => {
      subtotal += ((itemControl?.get("price").value * itemControl?.get('quantity').value) * this.getVatValue(itemControl?.get("vat").value));
    });

    return subtotal;
  }

  getGrandTotal(){
    var items = this.getGrandSubTotal();
    var vat = this.getTotalVat();
    var freight = this.purchaseOrder?.freightAmount ?? 0;

    return items + vat + freight;
  }
  
  // payments
  getPaymentTotal() {
    var subtotal = 0;

    this.paymentItems?.controls.forEach((itemControl: FormGroup) => {
      subtotal += itemControl?.get('amount').value;
    });

    return subtotal;
  }

  getStatusText(status: PurchaseOrderStatus) {
    return PurchaseOrderUtils.getStatusText(status);
  }

  getStatusStyle(status: PurchaseOrderStatus) {
    return PurchaseOrderUtils.getStatusStyle(status);
  }

  getStatusColour(status: PurchaseOrderStatus) {
    return PurchaseOrderUtils.getStatusColour(status);
  }

  getWorkOrderStatusName(status: WorkOrderStatus) {
    //todo
    return WorkOrderStatus[status].toString();
  }

  isDispatched() {
    return this.purchaseOrder.status == PurchaseOrderStatus.Dispatched;
  }

  isAwaitingCustomerApproval() {
    return this.purchaseOrder?.status == PurchaseOrderStatus.AwaitingCustomerApproval;
  }

  approveCustomerApproval() {
    this.buildModel();
    this.purchaseOrder.status = this.getGrandTotal() < 500 ? PurchaseOrderStatus.Approved : PurchaseOrderStatus.Created;

    if (this.purchaseOrder.status == PurchaseOrderStatus.Approved && !this.purchaseOrder.approvedByName) {
      var user = this.appAuth.getUser();
      this.purchaseOrder.approvedByName = `${user?.firstName} ${user?.lastName}`.trim();
      this.purchaseOrder.approvalDate = new Date().toISOString();
    }

    this.updatePurchaseOrder(false, true);
  }

  submitForApproval() {
    this.buildModel();
    this.purchaseOrder.status = PurchaseOrderStatus.PendingApproval;
    this.updatePurchaseOrder(false, true);
  }

  approvePo(accepted: boolean = true) {
    this.buildModel();
    this.purchaseOrder.status = accepted ? PurchaseOrderStatus.Approved : PurchaseOrderStatus.Rejected;

    if (!accepted) {
      this.updatePurchaseOrder(false, true);
      return;
    }

    // Approved — capture audit trail
    var user = this.appAuth.getUser();
    this.purchaseOrder.approvedByName = `${user?.firstName} ${user?.lastName}`.trim();
    this.purchaseOrder.approvalDate = new Date().toISOString();

    // Save approval first, then cascade everything
    this.loader.open();
    this.purchaseOrderService.apiPurchaseOrderUpdatePurchaseOrderPost$Json({ body: this.purchaseOrder }).subscribe({
      next: (res) => {
        if (!res?.data) { this.loader.close(); return; }

        this.cdr.detectChanges();

        // Create WOs (fire-and-forget, non-blocking)
        if (this.purchaseOrderId && !this.purchaseOrder.isDraft) {
          for (var productItem of this.getProductItemsRequiringButWithoutWorkOrder()) {
            var productId = (productItem as UntypedFormArray).controls['productId'].value;
            var quantity = (productItem as UntypedFormArray).controls['quantity'].value;
            var workOrder = <WorkOrderListDto>{
              isFullShipment: this.workOrderFormGroup?.get('isWorkOrderFullShipment')?.value,
              startDate: this.workOrderFormGroup?.get('workOrderStartDate')?.value ?? new Date().toISOString(),
              dueDate: this.workOrderFormGroup?.get('workOrderDueDate')?.value,
              priority: this.workOrderFormGroup?.get('workOrderPriority')?.value,
              deliveryNotes: this.workOrderFormGroup?.get('workOrderNotes')?.value,
              salesOrderId: this.purchaseOrderId,
              productId: +productId,
              quantity: quantity,
              manufactureColumnDefinitionId: this.purchaseOrder?.manufactureColumnDefinitionId ?? null,
            };
            this.workOrderService.apiWorkOrderAddWorkOrderPost$Json$Response({ body: workOrder }).subscribe({
              next: (woRes) => {
                if (woRes?.body?.data) this.purchaseOrder.workOrders.push(woRes.body.data);
              },
              error: () => {} // WO creation is best-effort
            });
          }
        }

        // Generate pick sheet (fire-and-forget, non-blocking)
        if (this.isSalesOrder() && this.purchaseOrderId) {
          this.pickSheetService.apiPickSheetGeneratePost$Json$Response({
            purchaseOrderId: this.purchaseOrderId
          }).subscribe({ error: () => {} });
        }

        // SAO — fetch quote creator email, generate PDF, show email dialog
        if (this.isSalesOrder()) {
          this.purchaseOrderService.apiPurchaseOrderQuoteCreatorEmailGet$Json$Response({
            purchaseOrderId: this.purchaseOrderId
          }).subscribe({
            next: (emailRes) => {
              var quoteCreatorEmail = emailRes?.body?.data ?? emailRes?.body?.message ?? '';

              this.showPrintPreview();
              this.purchaseOrderPreview.generatePdf().then(PDF => {
                this.hidePrintPreview();
                this.loader.close();

                var soRef = this.purchaseOrder?.salesOrderRef ?? 'ORD-NEX-' + this.purchaseOrderId.toString().padStart(4, '0');
                var dialog = this.dialog.open(AddItemDialogComponent, {
                  data: {
                    title: "Approved — Send SAO to Client",
                    items: [
                      { name: 'to', initialValue: quoteCreatorEmail || '', mandatory: true },
                      { name: 'subject', initialValue: `Sales Approval Order: ${soRef} - ${this.purchaseOrder.company}`, mandatory: true },
                      { name: 'body', type: 'textarea', mandatory: true, initialValue:
                        `Hi,\n\n` +
                        `The Sales Approval Order for ${soRef} (${this.purchaseOrder.company}) has been approved and is ready to be sent to the client.\n\n` +
                        `Please find the SAO attached.\n\n` +
                        `Approved by: ${this.purchaseOrder.approvedByName}\n` +
                        `Approval date: ${new Date(this.purchaseOrder.approvalDate).toLocaleDateString('en-GB')}\n\n` +
                        `Best regards,\n` +
                        this.appInfo.companyName
                      },
                    ],
                    overrideSaveText: 'Send & Close',
                    overrideWidth: 65,
                  }
                });

                dialog.afterClosed().subscribe((dialogRes) => {
                  if (dialogRes) {
                    this.sendPurchaseOrderEmail(PDF, dialogRes.to, dialogRes.subject, dialogRes.body);

                    if (this.purchaseOrder?.dealId) {
                      var blob = PDF.output('blob');
                      var filename = `SAO-${soRef}.pdf`;
                      this.dealService.apiDealUploadFileDealIdPost$Plain$Response({
                        dealId: this.purchaseOrder.dealId,
                        filename: filename,
                        isBom: false,
                        body: { formFile: blob }
                      }).subscribe();

                      this.purchaseOrderService.apiPurchaseOrderSalesHandoverNotificationPost$Json$Response({
                        purchaseOrderId: this.purchaseOrderId
                      }).subscribe();
                    }
                  }

                  this.dialogRef.close(null);
                });
              }).catch(() => {
                this.hidePrintPreview();
                this.loader.close();
                this.dialogRef.close(null);
              });
            },
            error: () => {
              // Email fetch failed — still close cleanly
              this.loader.close();
              this.dialogRef.close(null);
            }
          });
        } else {
          this.loader.close();
          this.dialogRef.close(null);
        }
      },
      error: () => {
        this.loader.close();
      }
    });
  }

  triggerSaoHandover() {
    // Also send notification
    this.purchaseOrderService.apiPurchaseOrderSalesHandoverNotificationPost$Json$Response({
      purchaseOrderId: this.purchaseOrderId
    }).subscribe();

    this.salesHandover();
  }

  salesHandover() {
    this.loader.open();

    // Fetch quote creator email first, then generate PDF
    this.purchaseOrderService.apiPurchaseOrderQuoteCreatorEmailGet$Json$Response({
      purchaseOrderId: this.purchaseOrderId
    }).subscribe(emailRes => {
      var quoteCreatorEmail = emailRes?.body?.data ?? emailRes?.body?.message ?? '';

      this.showPrintPreview();
      this.purchaseOrderPreview.generatePdf().then(PDF => {
        this.hidePrintPreview();
        this.loader.close();

        var soRef = this.purchaseOrder?.salesOrderRef ?? 'ORD-NEX-' + this.purchaseOrderId.toString().padStart(4, '0');
        var dialog = this.dialog.open(AddItemDialogComponent, {
          data: {
            title: "Sales Handover — Send SAO",
            items: [
              { name: 'to', initialValue: quoteCreatorEmail || '', mandatory: true },
            { name: 'subject', initialValue: `Sales Approval Order Ready: ${soRef} - ${this.purchaseOrder.company}`, mandatory: true },
            { name: 'body', type: 'textarea', mandatory: true, initialValue:
              `Hi,\n\n` +
              `The Sales Approval Order for ${soRef} (${this.purchaseOrder.company}) has been approved and is ready to be sent to the client.\n\n` +
              `Please find the SAO attached. Responsibility lies with the original quote creator to issue this to the client.\n\n` +
              `Approved by: ${this.purchaseOrder.approvedByName ?? 'N/A'}\n` +
              `Approval date: ${this.purchaseOrder.approvalDate ? new Date(this.purchaseOrder.approvalDate).toLocaleDateString('en-GB') : 'N/A'}\n\n` +
              `Best regards,\n` +
              this.appInfo.companyName
            },
          ],
          overrideSaveText: 'Send',
          overrideWidth: 65,
        }
      });

      dialog.afterClosed().subscribe((dialogRes) => {
        if (dialogRes) {
          this.sendPurchaseOrderEmail(PDF, dialogRes.to, dialogRes.subject, dialogRes.body);

          // Attach SAO PDF to the originating Deal/Quote
          if (this.purchaseOrder?.dealId) {
            var blob = PDF.output('blob');
            var filename = `SAO-${soRef}.pdf`;
            this.dealService.apiDealUploadFileDealIdPost$Plain$Response({
              dealId: this.purchaseOrder.dealId,
              filename: filename,
              isBom: false,
              body: { formFile: blob }
            }).subscribe();
          }
        }

        // Close the builder dialog
        this.dialogRef.close(null);
      });
      });
    });
  }

  sendToSupplier() {
    this.loader.open();
    this.showPrintPreview();
    this.purchaseOrderPreview.generatePdf().then(PDF => {
      this.hidePrintPreview();
      this.loader.close();
      this.askToSendEmail(PDF);
    });
  }

  updateStatus(event: MatSelectChange) {
    this.purchaseOrder.status = event.value;
    this.updatePurchaseOrder(false, true);
  }

  generateGoodsIn() {
    this.openReceipt(this.grnId ?? null);
  }

  openReceipt(goodsInReceiptId: number = null, isCount: boolean = false, isView: boolean = false) {
    var dialog = this.dialog.open(GoodsInDialogComponent, {
        autoFocus: false,
        data: {
            receiptId: goodsInReceiptId,
            isCount: isCount,
            isView: isView,
            purchaseOrderId: this.purchaseOrderId,
        }
    });
  
    dialog.afterClosed().subscribe((dialogRes) => {
        if (!dialogRes) return;

        var grn = dialogRes.form as GoodsInReceiptDto;
        grn.goodsInReceiptId = goodsInReceiptId;

        if(goodsInReceiptId)
          this.goodsInService.apiGoodsInUpdateGoodsInPost$Json$Response({body: grn}).subscribe(res => {
            if(!res?.body?.data) return;
            // this.loadReceipts();
            
            this.updatePoStatus(grn);
            this.updatePartStockAndLocations(grn, dialogRes.isNewlyCompleted);

            if(dialogRes.openCount)
              this.openCount(goodsInReceiptId);
          });
        else
          this.goodsInService.apiGoodsInAddGoodsInPost$Json$Response({body: grn}).subscribe(res => {
            if(!res?.body?.data) return;
            // this.loadReceipts();

            //upload any images
            for(var imgData of dialogRes.queuedImages)
              this.goodsInService.apiGoodsInUploadFileGoodsInReceiptIdPost$Json({ ...imgData, goodsInReceiptId: res.body.data.goodsInReceiptId }).subscribe(res => {
                if(!res?.data)
                  console.log("failed to upload image for new goods in receipt");
              });
            
            this.updatePoStatus(grn);
            this.updatePartStockAndLocations(grn, dialogRes.isNewlyCompleted);
              
            if(dialogRes.openCount)
              this.openCount(res.body.data.goodsInReceiptId);
          });
    });
  }

  updatePoStatus(grn: GoodsInReceiptDto) {
    if(!grn.purchaseOrderId) return;

    var status =
      grn.status == GoodsInStatus.Completed ? PurchaseOrderStatus.Complete :
      grn.isPartial ? PurchaseOrderStatus.PartialReceived :
      PurchaseOrderStatus.Received
    
    this.purchaseOrderService.apiPurchaseOrderUpdateStatusPost$Json$Response({purchaseOrderId: grn.purchaseOrderId, status: status}).subscribe(res => {
      if(!res?.body?.data) return;
    });
  }

  updatePartStockAndLocations(grn: GoodsInReceiptDto, updateLastReceivedDate: boolean = false) {
    if(grn.status == GoodsInStatus.Completed) {
      this.partService.apiPartUpdateStockAndLocationsFromGoodsInPut$Json$Response({body: grn, updateLastReceivedDate: updateLastReceivedDate}).subscribe(res => {
        if(!res?.body?.data) return;
      });
    }
  }

  openCount(goodsInReceiptId: number) {
    this.openReceipt(goodsInReceiptId, true);
  }

  getAllowedStatuses(): EnumViewModel[] {
    var statusList: PurchaseOrderStatus[] = [];

    if(this.isPurchaseOrder())
      statusList = [
        PurchaseOrderStatus.Approved,
        PurchaseOrderStatus.Ordered,
        PurchaseOrderStatus.Dispatched,
        PurchaseOrderStatus.PartialReceived,
        PurchaseOrderStatus.Received,
        PurchaseOrderStatus.Complete,
      ];
    else if(this.isHireOrder() || this.isSalesOrder())
      statusList = [
        PurchaseOrderStatus.Approved,
        PurchaseOrderStatus.Picking,
        PurchaseOrderStatus.InProduction,
        PurchaseOrderStatus.Dispatched,
        PurchaseOrderStatus.PartialReceived,
        PurchaseOrderStatus.Received,
        PurchaseOrderStatus.Complete,
      ];
      
    return statusList.map(x => <EnumViewModel> {name: this.getStatusText(+x), value: <PurchaseOrderStatus>x});
  }

  save(draft: boolean = false, download: boolean = false, navigate: boolean = true) {
    this.buildModel(draft);
    this.submit(download, navigate);
  }

  submit(download: boolean, navigate: boolean) {
    if(!this.purchaseOrder?.purchaseOrderId) {
      this.createPurchaseOrder(download, navigate);
    } else {
      this.updatePurchaseOrder(download, navigate);
    }
  }

  createPurchaseOrder(download: boolean, navigate: boolean) {
    this.loader.open();
    this.purchaseOrderService.apiPurchaseOrderAddPurchaseOrderPost$Json({ body: this.purchaseOrder }).subscribe(res => {
      if(!res?.data) return;
      
      this.purchaseOrder = res.data;
      this.cdr.detectChanges();

      this.afterSave(download, navigate);
    });
  }

  updatePurchaseOrder(download: boolean, navigate: boolean) {
    this.loader.open();
    this.purchaseOrderService.apiPurchaseOrderUpdatePurchaseOrderPost$Json({ body: this.purchaseOrder }).subscribe(res => {
      if(!res?.data) return;
      
      this.cdr.detectChanges();

      this.afterSave(download, navigate);
    });
  }

  afterSave(download: boolean, navigate: boolean) {
    this.loader.close();

    if(this.purchaseOrderId && !this.purchaseOrder.isDraft) {
      // Create WOs
      for(var productItem of this.getProductItemsRequiringButWithoutWorkOrder()) {
        var productId = (productItem as UntypedFormArray).controls['productId'].value;
        var quantity = (productItem as UntypedFormArray).controls['quantity'].value;
        var workOrder = <WorkOrderListDto> {
          isFullShipment: this.workOrderFormGroup?.get('isWorkOrderFullShipment')?.value,
          startDate: this.workOrderFormGroup?.get('workOrderStartDate')?.value ?? new Date().toISOString(),
          dueDate: this.workOrderFormGroup?.get('workOrderDueDate')?.value,
          priority: this.workOrderFormGroup?.get('workOrderPriority')?.value,
          deliveryNotes: this.workOrderFormGroup?.get('workOrderNotes')?.value,
          salesOrderId: this.purchaseOrderId,
          productId: +productId,
          quantity: quantity,
          manufactureColumnDefinitionId: this.purchaseOrder?.manufactureColumnDefinitionId ?? null,
        };
        this.workOrderService.apiWorkOrderAddWorkOrderPost$Json$Response({body: workOrder}).subscribe(res => {
          if(!res?.body?.data) return;
          this.purchaseOrder.workOrders.push(res.body.data);
        });
      }

      // Generate pick sheet
      if (this.isSalesOrder()) {
        this.pickSheetService.apiPickSheetGeneratePost$Json$Response({
          purchaseOrderId: this.purchaseOrderId
        }).subscribe({ error: () => {} });
      }

      // Trigger SAO cascade if SO is now Approved
      if (this.isSalesOrder() && this.purchaseOrder?.status == PurchaseOrderStatus.Approved) {
        this.triggerSaoHandover();
        return; // Don't navigate — salesHandover will close the dialog
      }
    }

    if(navigate)
      this.dialogRef.close(null);
  }

  askToSendEmail(PDF: jsPDF, navigate: boolean = true) {
    var orderType = this.isPurchaseOrder() ? 'Purchase Order' : 'Sales Order';

    const confirmation = this._fuseConfirmationService.open({
      title  : 'Send Email',
      message: `Would you like to email this ${orderType.toLowerCase()} to the ${this.isPurchaseOrder() ? 'supplier' :  'client'}?`,
      actions: {
          confirm: {
              label: 'Yes',
          },
          cancel: {
            label: 'No',
          }
      },
    });

    confirmation.afterClosed().subscribe((result) => {
      if (result === 'confirmed') {

          var dialog = this.dialog.open(AddItemDialogComponent, {
              data: {
                  title: "Send Email",
                  items: [
                      {name: 'to', initialValue: this.contact.email ?? "", mandatory: true},
                      {name: 'subject', initialValue: `Confirmed ${orderType} ${this.purchaseOrder?.salesOrderRef ?? 'ORD-NEX-' + this.purchaseOrderId.toString().padStart(4, '0')} - ${this.appInfo.companyName}`, mandatory: true},
                      {name: 'body', type: 'textarea', mandatory: true, initialValue:
                        `Dear ${this.contact.name},\n\n` +
                        "I hope you are doing well.\n\n" +
                        `Please find attached the ${orderType} ${this.purchaseOrder?.salesOrderRef ?? 'ORD-NEX-' + this.purchaseOrderId.toString().padStart(4, '0')} for ${this.purchaseOrder.company ?? this.purchaseOrder.supplier} as discussed. The details of the order, including quantities, pricing, and delivery instructions, are outlined in the document.\n\n` +
                        "Kindly confirm receipt of this order and let us know if you have any questions or require further clarification.\n" +
                        "Thank you for your prompt attention to this order, and we look forward to your confirmation.\n\n" +
                        "Best regards,\n" +
                        this.appInfo.companyName},
                  ],
                  overrideSaveText: 'Send',
                  overrideWidth: 65,
              }
          });

          dialog.afterClosed().subscribe((dialogRes) => {
              if (!dialogRes) return;
              
              this.sendPurchaseOrderEmail(PDF, dialogRes.to, dialogRes.subject, dialogRes.body);

              if(this.isPurchaseOrder()) {
                this.purchaseOrder.status = PurchaseOrderStatus.Ordered;
                this.updatePurchaseOrder(false, navigate);
              }
              else if(navigate)
                this.navigateToPurchaseOrderList();
          });
      }
    });
  }

  sendPurchaseOrderEmail(PDF: jsPDF, to: string, subject: string, body: string) {
    var blob = PDF.output('blob');

    var request = {
      purchaseOrderId: this.purchaseOrderId,
      filename: this.purchaseOrderPreview.GetPOTitle(),
      emailTo: to,
      emailSubject: subject,
      emailBody: body,
      body: {
        formFile: blob
      }
    };
    
    this.purchaseOrderService.apiPurchaseOrderSendPurchaseOrderEmailPost$Json$Response(request).subscribe(res => {
      if(!res?.body?.data) return;

    });
  }

  openBomInfo(bom: BomDto, productQuantity: number = 1) {
    this._infoDialogService.open({
        panelClass: 'custom-confirmation-dialog-panel',
        title  : `<div class="sm:mt-2">BOM-${new Date(bom.createdDate).getFullYear()}-${ bom.bomId.toString().padStart(3, '0')}</div>`,
        message: `
          <br/>
          <div class="max-h-[70vh] overflow-y-scroll sm:-mr-8">
            <div class="grid grid-cols-8 gap-3 sm:gap-x-6">
              <div>Level</div>
              <div class="col-span-4">Part</div>
              <div class="col-span-2">Total Required / In Stock</div>
              <div>Short</div>
              ${bom.items.map(item => {
                var part = this.parts?.find(p => p.id == item.partId);
                var requiredAmount = item.quantity * productQuantity;
                var inStock = part?.currentStock ?? 0;

                return `
                <div class="pl-${(item.level.split('.').length - 1) * 2}">${item.level}</div>
                <div class="col-span-4">
                  <div>${part?.number ?? '-'}</div>
                  <div class="text-md line-clamp-2">${part?.description ?? ''}</div>
                </div>
                <div class="col-span-2 ${inStock >= requiredAmount ? 'text-green-500' : 'text-red-500'}">${requiredAmount} / ${inStock}</div>
                <div>${inStock >= requiredAmount ? '-' : requiredAmount - inStock}</div>
                `}).join('')}
            </div>
          </div>
          `
        ,
        actions: {
            confirm: {
              label: 'Close',
            },
            cancel: {
              show: false,
            }
        },
        icon: {
            name: 'mat_outline:shopping_cart',
            color: 'primary',
        },
      });
  }
  
  openWorkOrderInfo(workOrderId: number) {
    this.dialog.open(WorkOrderDialogComponent, {
          autoFocus: false,
            data: {
              workOrderId: workOrderId,
            }
      }).afterClosed().subscribe(_ => {
        this.loadPurchaseOrder();
      });
  }

  downloadPdf() {
    this.loader.open();
    this.showPrintPreview();
    this.purchaseOrderPreview.generatePdf().then(PDF => {
      this.hidePrintPreview();
      this.loader.close();
      this.exportPDF(PDF);
    });
  }

  exportPDF(PDF: jsPDF) {
    PDF.save(this.purchaseOrderPreview.GetPOTitle());
  }

  private showPrintPreview() {
    var doc = document.getElementById('print-preview');
    doc.style.display = 'block';
  }
  private hidePrintPreview() {
    var doc = document.getElementById('print-preview');
    if(!doc) return;
    doc.style.display = 'none';
  }

  navigateToPurchaseOrderList() {
    this.close();
  }

  openLinkedPo(purchaseOrderId: number) {
    this.dialog.open(PurchaseOrderBuilderComponent, {
      data: {
        purchaseOrderId: purchaseOrderId,
        IsSupplier: (this.isHireOrder() || this.isSalesOrder()),
        IsProduct: this.isPurchaseOrder(),
      },
      autoFocus: false,
    }).afterClosed().subscribe(() => {
      this.loadPurchaseOrder();
    });
  }
  
      
  toggleStandby(itemControl: UntypedFormArray, change: MatCheckboxChange): void
  {
      itemControl.controls['isStandby'].setValue(change.checked);

      var asset = this.assets.find(x => x.name == itemControl.controls['description'].value);

      itemControl.controls['price'].setValue(change.checked ? (asset?.standbyPrice ?? 0) : asset?.price);
  }

  onStepChange(event: StepperSelectionEvent) {
    // console.log('Moved from', event.previouslySelectedStep.label, 'to', event.selectedStep.label);

    if(event.selectedStep.label == 'Preview') {
      this.buildModel(this.canSaveAsDraft);
    }
  }

  close() {
      this.dialogRef.close(null);
  }

  trackByFn(index: number, item: any): any
  {
      return item.id || index;
  }


  // Work Orders
  changeFulfilmentOption(event: MatRadioChange) {
      this.workOrderFormGroup.controls['isWorkOrderFullShipment'].setValue(event?.value ?? false);
  }
}
